import axios from 'axios';
import { toast } from 'react-hot-toast';

import { apiUrl } from '../apiUrl';

const sortByAge = (groups) => groups.sort((a, b) => a.age_int - b.age_int);

export const fetchGroups = async () => {
  try {
    const resp = await axios.get(`${apiUrl}/ages`);

    return sortByAge(resp.data.ages);
  } catch (error) {
    console.log(error);
    toast.error('Wystąpił problem. Odśwież aplikację.');
  }
};
